export const SHARED_MEDIA_OPEN_MODAL = "SHARED_MEDIA_OPEN_MODAL";
export const SHARED_MEDIA_SHARE_MEDIA = "SHARED_MEDIA_SHARE_MEDIA";
export const SHARED_MEDIA_SHARE_MEDIA_RESPONSE = "SHARED_MEDIA_SHARE_MEDIA_RESPONSE";
export const SHARED_MEDIA_GET_SHARED_MEDIA = "SHARED_MEDIA_GET_SHARED_MEDIA";
export const SHARED_MEDIA_GET_SHARED_MEDIA_RESPONSE = "SHARED_MEDIA_GET_SHARED_MEDIA_RESPONSE";